import { render, staticRenderFns } from "./SsoButton.vue?vue&type=template&id=6e585bb2&scoped=true"
import script from "./SsoButton.vue?vue&type=script&lang=js"
export * from "./SsoButton.vue?vue&type=script&lang=js"
import style0 from "./SsoButton.vue?vue&type=style&index=0&id=6e585bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e585bb2",
  null
  
)

export default component.exports